import { jsxs as u, jsx as y } from "react/jsx-runtime";
import { a as m } from "../../core-DVmjA3_O.js";
import { _ as V } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import S from "../InlineLayout/index.js";
import '../../index14.css';const f = "_button-layout_3xra5_1", b = "_before_3xra5_20", z = "_after_3xra5_21", p = "_with-full-width_3xra5_25", h = "_color-variant-text_3xra5_29", v = "_color-variant-text-on-dark_3xra5_33", T = "_color-variant-primary_3xra5_37", g = "_color-variant-secondary_3xra5_41", O = "_color-variant-success_3xra5_45", w = "_color-variant-danger_3xra5_49", F = "_style-variant-outline_3xra5_53", k = "_style-variant-filled_3xra5_58", L = "_style-variant-transparent_3xra5_62", D = "_style-variant-translucent_3xra5_68", N = "_style-variant-action_3xra5_74", C = "_text-size-extra-small_3xra5_80", P = "_text-size-small_3xra5_84", A = "_text-size-medium_3xra5_88", W = "_text-size-large_3xra5_92", E = "_disabled_3xra5_96", I = "_visual-feedback_3xra5_100", M = "_readOnly_3xra5_122", a = {
  buttonLayout: f,
  before: b,
  after: z,
  withFullWidth: p,
  colorVariantText: h,
  colorVariantTextOnDark: v,
  colorVariantPrimary: T,
  colorVariantSecondary: g,
  colorVariantSuccess: O,
  colorVariantDanger: w,
  styleVariantOutline: F,
  styleVariantFilled: k,
  styleVariantTransparent: L,
  styleVariantTranslucent: D,
  styleVariantAction: N,
  textSizeExtraSmall: C,
  textSizeSmall: P,
  textSizeMedium: A,
  textSizeLarge: W,
  disabled: E,
  visualFeedback: I,
  readOnly: M
}, j = {
  text: a.colorVariantText,
  primary: a.colorVariantPrimary,
  secondary: a.colorVariantSecondary,
  success: a.colorVariantSuccess,
  danger: a.colorVariantDanger,
  "text-on-dark": a.colorVariantTextOnDark
}, B = {
  outline: a.styleVariantOutline,
  filled: a.styleVariantFilled,
  transparent: a.styleVariantTransparent,
  translucent: a.styleVariantTranslucent,
  action: a.styleVariantAction
}, q = {
  xs: a.textSizeExtraSmall,
  sm: a.textSizeSmall,
  md: a.textSizeMedium,
  lg: a.textSizeLarge
};
function R(r) {
  const {
    colorVariant: e = "secondary",
    styleVariant: n = "translucent",
    spacingOffset: i,
    className: l,
    disabled: o,
    children: s,
    withoutPadding: c = !1,
    withFullWidth: _ = !1,
    textSize: t,
    readOnly: x,
    ...d
  } = r;
  return /* @__PURE__ */ u(
    S,
    {
      withPadding: !c,
      className: V(
        a.buttonLayout,
        j[e],
        B[n],
        o && a.disabled,
        _ && a.withFullWidth,
        m(t) && q[t],
        x && a.readOnly,
        l
      ),
      spacingOffset: i,
      withAdditionalInlinePadding: !0,
      withInlineDisplay: !0,
      beforeContainerClassName: a.before,
      afterContainerClassName: a.after,
      ...d,
      children: [
        s,
        /* @__PURE__ */ y("span", { className: a.visualFeedback })
      ]
    }
  );
}
export {
  R as default
};
